import React from 'react';

// The money moment: a technician is about to send an estimate or an invoice to
// their own customer, and they have no way to be paid for it.
//
// This is the pattern every marketplace lands on. Joining is free and fast, so
// nobody is turned away at the door. The bank details are asked for at the one
// moment the technician actually wants something, which is when they will
// happily spend five minutes on it.
//
// Not now is a real answer. The document still goes out and the customer still
// pays by check, exactly as before. Blocking the send would punish the
// technician for a setting, and the customer for nothing at all.
export default function StripeRequiredSheet({ onSetUp, onNotNow, busy }) {
  return (
    <div className="srq-backdrop" role="dialog" aria-modal="true" aria-labelledby="srq-title" onClick={onNotNow}>
      <div className="srq-sheet" onClick={e => e.stopPropagation()}>
        <div className="srq-art" aria-hidden="true">
          <div className="srq-ring">
            <span className="srq-logo srq-stripe">stripe</span>
            <span className="srq-logo srq-hub">QPS</span>
          </div>
        </div>

        <h2 className="srq-title" id="srq-title">Set up payments first</h2>
        <p className="srq-body">
          Connect your bank so this customer can pay you online, by bank transfer or card. Stripe asks for your ID and
          your bank account, and takes about five minutes.
        </p>

        <div className="srq-actions">
          <button type="button" className="srq-btn srq-later" disabled={busy} onClick={onNotNow}>Not now</button>
          <button type="button" className="srq-btn srq-go" disabled={busy} onClick={onSetUp}>
            {busy ? 'Opening…' : 'Set up payments'}
          </button>
        </div>

        {/* Said plainly, because a technician who taps Not now needs to know
            nothing broke. */}
        <p className="srq-note">Tap Not now and the document still goes out. Your customer pays you the usual way.</p>
      </div>
    </div>
  );
}
